// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'leagueGothic', 'leagueGothic Fallback'"},"className":"__className_68df5a","variable":"__variable_68df5a"};